import { ICoherenceBreadcrumbStyles } from "@coherence-design-system/breadcrumb";
import { IStyleFunctionOrObject } from "@fluentui/merge-styles";
import {
  IComboBoxStyles,
  IDatePickerStyleProps,
  IDatePickerStyles,
  IStackItemStyles,
} from "@fluentui/react";

export const cardWidth850 = { root: { width: "850px", paddingBottom: "10px" } };
export const BreadcrumbStyle: Partial<ICoherenceBreadcrumbStyles> = {
  listItem: {
    color: "#605E5C",
  },
  item: {
    color: "#605E5C",
  },
  itemLink: {
    color: "#605E5C",
  },
};

export const LoadingContainerStyle = {
  height: "500px",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const GrayText = {
  color: "#605E5C",
};

export const textFieldStyles = {
  fieldGroup: { width: "350px" },
};
//, height: "32px", radius: "2px", border: "1px"
export const textFieldGrayStyles = {
  fieldGroup: {
    width: "350px",
    backgroundColor: "rgb(237, 235, 233)", // set the color to a lighter shade of gray
    color: "rgb(237, 235, 233)"
  },
};
export const datePickerGrayStyles: IStyleFunctionOrObject<
  IDatePickerStyleProps,
  IDatePickerStyles
> = {
  textField: {
    "& label": {
      color: "rgb(237, 235, 233)",
    },
    "& input": {
      color: "rgb(237, 235, 233)",
    },
    "& .ms-TextField-fieldGroup": {
      width: "320px",
      borderColor: "rgb(237, 235, 233)",
    },
    "& i": {
      color: "rgb(237, 235, 233)",
    },
  },
};
export const datePickerStyles: IStyleFunctionOrObject<
  IDatePickerStyleProps,
  IDatePickerStyles
> = {
  textField: {
    "& label": {
      color: "rgb(50, 49, 48)",
    },
    "& input": {
      color: "rgb(50, 49, 48)",
      // backgroundColor: "rgb(237, 235, 233)",
    },
    "& .ms-TextField-fieldGroup": {
      width: "350px",
      // backgroundColor: "rgb(237, 235, 233)",
      borderColor: "rgb(50, 49, 48)",
    },
    "& i": {
      color: "rgb(50, 49, 48)",
    },
  },
};
export const errorDatePickerStyles: IStyleFunctionOrObject<
  IDatePickerStyleProps,
  IDatePickerStyles
> = {
  textField: {
    "& label": {
      color: "rgb(50, 49, 48)",
    },
    "& input": {
      color: "rgb(50, 49, 48)",
      // backgroundColor: "rgb(237, 235, 233)",
    },
    "& .ms-TextField-fieldGroup": {
      width: "350px",
      // backgroundColor: "rgb(237, 235, 233)",
      borderColor: "rgb(164, 38, 44)",
    },
    "& i": {
      color: "rgb(50, 49, 48)",
    },
  },
};

export const comboBoxStyles: Partial<IComboBoxStyles> = {
  root: {
    width: 350,
  },
};
export const disbaledComboBoxStyles: Partial<IComboBoxStyles> = {
  root: {
    width: 320,
    borderColor: "rgb(50, 49, 48)",
    color: "rgb(50, 49, 48)",
    "& .ms-ComboBox-container": {
      "& .ms-ComboBox": {
        background: "yellow",
        borderWidth: 1,
        borderColor: "rgb(50, 49, 48)",
      },
    },
    div: {
      background: "green",
      borderWidth: 1,
      borderColor: "rgb(50, 49, 48)",
    },
    "& .ms-ComboBox": {
      background: "red",
      borderWidth: 1,
      borderColor: "rgb(50, 49, 48)",
      "& input": {
        color: "rgb(50, 49, 48)",
      },
      "& button": {
        "& span": {
          "& i": {
            color: "rgb(50, 49, 48)",
          },
        },
      },
    },
  },
  container: {
    borderColor: "rgb(50, 49, 48)",
    color: "rgb(50, 49, 48)",
  },
  label: {
    color: "rgb(50, 49, 48)",
  },
  input: {
    borderColor: "rgb(50, 49, 48)",
    color: "rgb(50, 49, 48)",
  },
};
export const MarginBlockEndStyle = {
  marginBlockStart: "1em",
  marginBlockEnd: "0.33em",
};
export const btn_width={
  root:{width: "140px"}
}

export const customerAccountDetailsstyle:IStackItemStyles={root:{width:'200px', wordBreak:'break-word' }}

